import { useCallback, useState } from "react";
import {
  faBookmark,
  faChevronRight,
  faShareNodes,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faBookmark as faBookmarkSolid,
  faSpinnerThird,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Message } from "primereact/message";
import { Link } from "react-router-dom";
import Share from "./Share";
import "./CardThumb.scss";
import { Helpers } from "../services/Helpers";

export default function CardThumb({
  api,
  logged,
  card,
  callbackFavorite,
  isFull = false,
}) {
  const [limitTag, setLimitTag] = useState(3);
  const [openShare, setOpenShare] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);

  const MessageTemplate = (
    <div className="bw-card-message-template">
      <h4>
        This video available for registered users only. Please, sign in to play.
      </h4>
      <Link to="/login">Sign in {">"}</Link>
    </div>
  );

  const setFavorite = useCallback(
    (uniq) => {
      setLoadingBtn(true);

      api(
        `api/providers/${process.env.REACT_APP_SLUG}/content-videos/${card.id}/favorites/check/`,
        {
          method: "PATCH",
        },
      ).then(({ ok }) => {
        if (ok) {
          if (uniq) callbackFavorite.favoritedUniq(true, card.id);
          else callbackFavorite.favorited(card.id);
        }

        setLoadingBtn(false);
      });
    },
    [api, card, callbackFavorite, setLoadingBtn],
  );

  const setUnFavorite = useCallback(
    (uniq) => {
      setLoadingBtn(true);

      api(
        `api/providers/${process.env.REACT_APP_SLUG}/content-videos/${card.id}/favorites/uncheck/`,
        {
          method: "DELETE",
        },
      ).then(({ ok }) => {
        if (ok) {
          if (uniq) callbackFavorite.favoritedUniq(false, card.id);
          else callbackFavorite.unFavorited(card.id);
        }

        setLoadingBtn(false);
      });
    },
    [api, card, callbackFavorite, setLoadingBtn],
  );

  const onChangeFavorite = useCallback(
    (uniq = false) => {
      if (card.favorited) setUnFavorite(uniq);
      else setFavorite(uniq);
    },
    [card, setFavorite, setUnFavorite],
  );

  return (
    <div className={"card-thumbnail " + (isFull ? "is-full" : "")}>
      {isFull ? (
        <div className="video">
          {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
          {logged ? (
            <iframe
              src={card.url}
              title="video"
              allow="autoplay; fullscreen; picture-in-picture"
            ></iframe>
          ) : (
            <div className="card-thumbnail-wrapper-thumb">
              <img src={card.thumbnail_large || card.thumbnail} alt="thumb" />
              <Message
                className="bw-card-message-thumbnail"
                severity="warn"
                text={MessageTemplate}
              ></Message>
            </div>
          )}
        </div>
      ) : (
        <div className="thumbnail">
          {card.thumbnail && (
            <figure>
              <img src={card.thumbnail} alt="thumb" />
            </figure>
          )}
          <div className="overlay"></div>
          <p>{Helpers.secondsInTime(card.duration)}</p>

          <Link to={"/event/" + card.id} className="bw-event-btn">
            Watch now
          </Link>
        </div>
      )}

      <div className="content">
        <div className="wrapper-info">
          <div className="wrapper-show-info">
            {/*<h4>{card.title || ""}</h4>*/}
            <h2>{card.title || ""}</h2>

            {!isFull ? (
              <div className="tags">
                {card.topics && card.topics.length
                  ? card.topics.slice(0, limitTag).map((item, key) => (
                      <Link
                        to={"/search?search=" + item.name}
                        className="bw-event-btn tag"
                        key={key}
                      >
                        {item.name}
                      </Link>
                    ))
                  : null}
                {card.topics && limitTag < card.topics.length ? (
                  <button
                    className="bw-event-btn"
                    onClick={() => setLimitTag(card.topics.length)}
                  >
                    +{card.topics.length - limitTag} more
                  </button>
                ) : null}
              </div>
            ) : null}
          </div>

          <div className="wrapper-hide-info">
            {isFull ? (
              <h4 className="pt-0">{card.description || ""}</h4>
            ) : (
              <h4 className="pt-3">
                {Helpers.limitString(card.description) || ""}
              </h4>
            )}
            <div className="info-footer py-2 mt-3">
              {!isFull ? (
                <>
                  <Link
                    to={"/event/" + card.id}
                    className="bw-event-btn details"
                  >
                    Details
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      style={{ color: "#212121" }}
                    />
                  </Link>

                  <SharedButtons
                    onClickShare={() => setOpenShare(!openShare)}
                    showShareName={isFull}
                    showShareIcons={openShare}
                    onClickFavorite={() => onChangeFavorite()}
                    card={card}
                    showFavoriteIcons={logged}
                    loadingBtn={loadingBtn}
                  />
                </>
              ) : null}
            </div>
          </div>
        </div>

        {isFull ? (
          <div
            className="tags mt-3"
            style={{
              justifyContent:
                card.topics && card.topics.length
                  ? "space-between"
                  : "flex-end",
            }}
          >
            <SharedButtons
              onClickShare={() => setOpenShare(!openShare)}
              showShareName={isFull}
              showShareIcons={openShare}
              onClickFavorite={() => onChangeFavorite(true)}
              card={card}
              showFavoriteIcons={logged}
              loadingBtn={loadingBtn}
            />

            {card.topics && card.topics.length ? (
              <div className="topics-list">
                {card.topics.slice(0, limitTag).map((item, key) => (
                  <Link
                    to={"/search?search=" + item.name}
                    className="bw-event-btn tag"
                    key={key}
                  >
                    {item.name}
                  </Link>
                ))}
                {limitTag < card.topics.length ? (
                  <button
                    className="bw-event-btn"
                    onClick={() => setLimitTag(card.topics.length)}
                  >
                    +{card.topics.length - limitTag} more
                  </button>
                ) : null}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}

const SharedButtons = ({
  onClickShare,
  showShareName,
  showShareIcons,
  onClickFavorite,
  card,
  showFavoriteIcons,
  loadingBtn,
}) => {
  return (
    <div className="bw-event-shared-buttons">
      {showFavoriteIcons ? (
        <>
          {!loadingBtn ? (
            <button
              className={
                "bw-event-btn favorite " + (card.favorited ? "is-favorite" : "")
              }
              onClick={onClickFavorite}
            >
              <FontAwesomeIcon
                className="not-favorite"
                icon={faBookmark}
                style={{ color: "#212121" }}
              />
              <FontAwesomeIcon
                className="is-favorite"
                icon={faBookmarkSolid}
                style={{ color: "#212121" }}
              />
            </button>
          ) : (
            <div className="bw-event-btn-loading">
              <FontAwesomeIcon icon={faSpinnerThird} />
            </div>
          )}
        </>
      ) : null}

      <button className="bw-event-btn share" onClick={onClickShare}>
        {showShareName ? "Shared" : ""}
        <FontAwesomeIcon icon={faShareNodes} style={{ color: "#212121" }} />
        {showShareIcons ? <Share url={"/event/" + card.id} /> : ""}
      </button>
    </div>
  );
};
